<template>

  <data-table
    :model="mappedEvents"
    :columns="computedColumns"
    :show-search="showSearch"
    v-loading.body="loading"
    :order="{ ascending: false, sortBy: 'occured' }" />

</template>

<script>
import EventListConfig from 'components/event/EventTableConfig'
import { post } from 'providers/http'
import moment from 'moment'
import _ from 'lodash'
import { ENTRY, REGISTRATION, SYSTEM, INPUT } from 'components/event/profiles'
import findAll from 'service/findAll'
import TOGGLE_PARAM_TYPES from 'components/event/toggleTypes'

export default {
  name: 'event-table',
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    profile: {
      type: String
    },
    columns: {
      type: Array
    }
  },
  data () {
    return {
      events: [],
      debouncedGetEvents: _.debounce(this.getEvents, 700),
      loading: false,
      timerId: null
    }
  },
  computed: {
    mappedEvents () {
      if (this.profile === ENTRY) {
        return this.events.map(event => {
          const additionalFields = {}

          const relatedSwitch = this.switches.find(s =>
            s.controller_id === event.controller_id && s.index === event.param % 20
          )

          if (relatedSwitch) {
            additionalFields.switchName = relatedSwitch.name
          }

          if (!event.mobile_id) {
            additionalFields.userName = this.$t('unknown')
            additionalFields.personName = this.$t('unknown')
          }

          if (event.param === 0) {
            additionalFields.type = this.$t('event.toggle.type.rfid')
            additionalFields.success = this.$t('event.toggle.success')
          }
          else if (event.param === 255) {
            additionalFields.type = this.$t('event.toggle.type.rfid')
            additionalFields.success = this.$t('event.toggle.fail-undefined')
          }
          else {
            const type = TOGGLE_PARAM_TYPES[Math.floor(event.param / 20)]

            if (type) {
              additionalFields.type = this.$t('event.toggle.type.' + type.type)
              additionalFields.success = this.$t('event.toggle.' + type.success)
            }
          }

          return { ...event, ...additionalFields }
        })
      }

      return this.events
    },
    computedColumns () {
      if (this.columns) {
        return this.columns
      }

      if (this.profile === ENTRY) {
        return ['occured', 'userName', 'personName', 'controllerName', 'switchName', 'type', 'success']
      }
      else if (this.profile === REGISTRATION) {
        return ['occured', 'name', 'userName', 'controllerName', 'controllerDescription']  /* we dont know: 'switchName'. The param is the new userId */
      }
      else if (this.profile === SYSTEM) {
        return ['occured', 'controllerName', 'controllerDescription', 'controllerIp', 'name']
      }
      else if (this.profile === INPUT) {
        return ['occured', 'name', 'user_name', 'controllerName', 'controllerDescription']
      }

      return ['occured', '[T]name', 'param', 'userName']
    }
  },
  methods: {
    async getEvents (showLoading = true) {
      this.loading = showLoading && true

      const events = await post('api/v1/events', this.filters)

      this.loading = false

      this.events = events.data.map(e => {
        e.occured = moment(e.occured).format(this.$t('format.longDate'))
        e.name = this.$t(`eventType.${e.name}`)

        return e
      })
    },
    refresh () {
      this.debouncedGetEvents(false)
      this.timerId = setTimeout(this.refresh, 15 * 1000)
    }
  },
  watch: {
    filters: {
      handler () { this.debouncedGetEvents() },
      deep: true
    },
    profile () {
      this.events = []
      this.loading = true
    }
  },
  created () {
    this.refresh()
  },
  beforeDestroy () {
    clearTimeout(this.timerId)
  },
  components: {
    EventListConfig
  },
  mixins: [
    findAll('switches')
  ]
}
</script>



// WEBPACK FOOTER //
// EventTable.vue?0534a070